<template>
  <div class="container">
    <h1>SMS Outbox
      <sdx-menu-flyout>
        <sdx-menu-flyout-toggle sr-hint="SPAM">
          <sdx-icon icon-name="icon-information-circle"></sdx-icon>
        </sdx-menu-flyout-toggle>
        <sdx-menu-flyout-content class="infotag">
          <h4>Wo finde ich den SPAM Ordner auf meinem Mobile</h4>
          <h5>Auf dem iPhone (iOS)</h5>
          <ol class="list single-line">
            <li>Öffnen Sie die <strong>Einstellungen</strong>.</li>
            <li>Scrollen Sie nach unten und tippen Sie auf <strong>Nachrichten</strong>.</li>
            <li>Stellen Sie sicher, dass die Option <strong>Unbekannte Absender filtern</strong> aktiviert ist.</li>
            <li>Öffnen Sie Ihre <strong>Nachrichten-App</strong> und tippen Sie oben links auf <strong>Filter</strong>.</li>
            <li>Wählen Sie den Ordner <strong>Unbekannte Absender</strong> oder <strong>Spam</strong> aus.</li>
          </ol>
          <br>
          <h5>Auf Android-Geräten (z.B. Google Messages, Samsung)</h5>
          <ol class="list single-line">
            <li>Öffnen Sie Ihre <strong>Nachrichten-App</strong> und tippen Sie oben links auf <strong>Filter</strong>.
            </li>
            <li>Wählen Sie den Ordner <strong>Unbekannte Absender</strong> oder <strong>Spam</strong> aus.</li>
            <li>Wählen Sie in der Liste <strong>Spam und blockiert</strong> oder <strong>Schutz & Sicherheit</strong> aus.</li>
            <li>Hier finden Sie alle herausgefilterten Nachrichten.</li>
          </ol>

        </sdx-menu-flyout-content>
      </sdx-menu-flyout>
    </h1>
    <div class="row margin-bottom-2">
      <div class="col-xs-4">
        <DevAppDropDownComponent role="sms" @devapp-changed="devAppChanged" :allSelectionEnabled="true"/>
      </div>
    </div>
    <sdx-loading-spinner id="spinner-outbox" data-tesId="spinner-outbox" size="large" sr-hint="Loading. Please wait."
                         class="spinner-dashboard hidden"></sdx-loading-spinner>
    <div id="outbox" v-if="showOutbox">
      <div class="row margin-bottom-2" style="padding-left: 12px">
        <div class="filter-item">
          <span class="filter-item-title">Country Code</span>
          <sdx-menu-flyout>
            <sdx-menu-flyout-toggle>
              <sdx-icon icon-name="icon-information-circle" sr-hint="Read more" data-testid="infoCC"></sdx-icon>
            </sdx-menu-flyout-toggle>
            <sdx-menu-flyout-content style="width: 400px;">
              <p>
                The country code is used to filter the destination number. The country code is the first part of
                the
                destination number. For example, if the destination number is +41791234567, the country code is
                CH.<br/>
                <br/>
                You can invert the selection by adding a `-` before the country code. For example, `-CH` will filter for
                other countries than Switzerland.
              </p>
              <p>
                A list of available country codes can be found on
                <a href="https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements"
                   target="_blank">Wikipedia</a>.
              </p>
            </sdx-menu-flyout-content>
          </sdx-menu-flyout>
          <sdx-input
              :value="countryCode"
              @input="handleTextInputChange($event.target.value, 'countryCode')"
          />
        </div>
        <div class="filter-item">
          <span class="filter-item-title">Destination Number</span>
          <!-- `+` is removed because `destinationNumber` is indexed in Elasticsearch with
              `analyzed` setting which removes non-alphanumeric chars, among other things -->
          <sdx-input
              data-testid="DestinationNumber"
              oninput="this.value = this.value.replace(/[\\+]/g, '')"
              type="number"
              :value="destinationNumber"
              @input="handleTextInputChange($event.target.value, 'destinationNumber')"
          />
        </div>
        <div class="filter-item">
          <span class="filter-item-title">Status</span>
          <sdx-select
              data-testid="statusDropDown"
              placeholder="Choose..."
              :value="statusFilter"
              @input="statusFilterChange"
              class="thick-border"
          >
            <sdx-select-option
                v-for="(statusElem, idx) in statusList"
                data-testid="statusDropDownOption"
                v-bind:value="statusElem"
                v-bind:key="idx"
            >
              {{ statusElem }}
            </sdx-select-option>
          </sdx-select>
        </div>
        <div class="filter-item" style="width: 150px"
             v-if="envService.featureToggleSmsTag()">
          <span class="filter-item-title">Tag</span>
          <sdx-menu-flyout>
            <sdx-menu-flyout-toggle>
              <sdx-icon icon-name="icon-information-circle" sr-hint="Read more" data-testid="infoTag"></sdx-icon>
            </sdx-menu-flyout-toggle>
            <sdx-menu-flyout-content style="width: 600px;">
              <p>
                {{ $t('commons.tag') }}
              </p>
            </sdx-menu-flyout-content>
          </sdx-menu-flyout>
          <sdx-input
              data-testid="tag"
              placeholder=""
              :value="tag"
              @input="handleTextInputChange($event.target.value, 'tag')"
          />

        </div>
        <div class="filter-item" style="width: 240px">
          <span class="filter-item-title">Sent Since</span>
          <sdx-menu-flyout>
            <sdx-menu-flyout-toggle>
              <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"
                        data-testid="infoSentSince"></sdx-icon>
            </sdx-menu-flyout-toggle>
            <sdx-menu-flyout-content style="width: 600px;">
              <p>
                SMS Outbox data exist only for 6 months back.
              </p>
            </sdx-menu-flyout-content>
          </sdx-menu-flyout>
          <sdx-input
              name="outboxFromDate"
              data-testid="sentSince"
              type="date"
              placeholder="01.01.2025 00:00:00"
              flatpickr-options='{"maxDate":"today", "dateFormat":"d.m.Y H:i:S", "locale":"de", "enableTime":"true", "enableSeconds":"true", "time_24hr":"true"}'
              :value="dateRange.fromDate"
              @input="fromDateChange"
          />
        </div>
        <!-- https://flatpickr.js.org/options/ -->
        <div class="filter-item" style="width: 240px">
          <span class="filter-item-title">Sent Until</span>
          <sdx-input
              name="outboxToDate"
              data-testid="sentUntil"
              type="date"
              placeholder="31.01.2025 23:59:59"
              flatpickr-options='{"maxDate":"today", "dateFormat":"d.m.Y H:i:S", "locale":"de", "enableTime":"true", "enableSeconds":"true", "time_24hr":"true", "defaultHour":"23", "defaultMinute":"59", "defaultSecond":"59"}'
              :value="dateRange.toDate"
              @input="toDateChange"
          />
        </div>
      </div>
      <sdx-loading-spinner id="spinner-outbox-content" size="large"
                           sr-hint="Loading. Please wait."></sdx-loading-spinner>
      <div id="outbox-content">
        <div id="sms_outbox">
          <div class="subscription-table table table--responsive table--highlight margin-v-1">
            <div class="table_wrapper">
              <table data-init="auto">
                <thead>
                <tr>
                  <th class="table-header">Country</th>
                  <th class="table-header">Destination Number</th>
                  <th class="table-header">SMS Parts</th>
                  <th>Status
                    <sdx-menu-flyout>
                      <sdx-menu-flyout-toggle>
                        <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"
                                  data-testid="infoDS"></sdx-icon>
                      </sdx-menu-flyout-toggle>
                      <sdx-menu-flyout-content style="width: 700px;">
                        <table>
                          <tbody>
                          <tr>
                            <td class="sc-blue legendStatusName">PROCESSING:</td>
                            <td> In the process of sending</td>
                          </tr>
                          <tr>
                            <td class="sc-blue legendStatusName">DELIVERED:</td>
                            <td>Successfully sent (without confirmation of receipt)</td>
                          </tr>
                          <tr>
                            <td class="sc-blue legendStatusName">CONFIRMED:</td>
                            <td>Successfully sent and confirmed by destination network or hub.<br/>(In the international
                              context, it is not a confirmation, especially with Provider Registration)
                            </td>
                          </tr>
                          <tr>
                            <td class="sc-blue legendStatusName">FAILURE:</td>
                            <td>Error occcured</td>
                          </tr>
                          <tr>
                            <td class="sc-blue legendStatusName">NO_INFO:</td>
                            <td>No status info</td>
                          </tr>
                          <tr>
                            <td class="sc-blue legendStatusName">BLOCKED:</td>
                            <td>Blocked (due to plan quota, throttling etc.)</td>
                          </tr>
                          </tbody>
                        </table>
                      </sdx-menu-flyout-content>
                    </sdx-menu-flyout>
                  </th>
                  <th class="table-header" v-if="envService.featureToggleSmsTag()">Tag</th>
                  <th class="table-header">Sent</th>
                  <th v-if="isSwisscom" class="table-header">Delivery Details</th>
                  <th v-if="isAdmin">
                    SBS
                    <sdx-menu-flyout>
                      <sdx-menu-flyout-toggle>
                        <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"
                                  data-testid="infoSbs"></sdx-icon>
                      </sdx-menu-flyout-toggle>
                      <sdx-menu-flyout-content style="width: 600px;">
                        <p>
                          Link to SBS WebGUI with this phone number to get more detailed information about sending
                          status.
                        </p>
                      </sdx-menu-flyout-content>
                    </sdx-menu-flyout>
                  </th>
                  <th v-if="isAdmin && this.webId === 'all_apps'" class="table-header">Client Id</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(item, itemIndex) in statisticOutbox" :key="item.id || itemIndex">
                  <tr class="sms-outbox-row">
                    <td class="table-cell smallercells">
                      <FlagComponent :country="item['destRegionCode']"/>
                    </td>
                    <td>{{ item.destination }}</td>
                    <td>{{ item.amount }}</td>
                    <td>
                      {{ item.status }}
                      <span
                          v-if="item.smsDetails.length > 1"
                          class="expandable-indicator"
                          role="button"
                          aria-label="Show more details"
                          @click.stop="toggleRowExpansion(item)"
                      >
                        <i class="icon icon-arrow-down" v-if="!expandedRows[item.id || itemIndex]"></i>
                        <i class="icon icon-arrow-up" v-if="expandedRows[item.id || itemIndex]"></i>
                      </span>
                    </td>
                    <td v-if="envService.featureToggleSmsTag()">
                      <p>
                        <span v-for="tagEntry in item.tagArray" :key="tagEntry"><span class="sms-tag">{{
                            tagEntry
                          }}</span>&nbsp;</span>
                      </p>
                    </td>
                    <td :title="'Last Update: ' + item.lastUpdated">{{ item.sent }}</td>

                    <td v-if="!item.smsDetails || item.smsDetails.length==0" class="message-length">&nbsp;</td>
                    <td v-else-if="isAdmin && item.smsDetails.length > 1" class="message-length">...</td>
                    <td v-else-if="isSwisscom" class="message-length">
                      <template
                          v-if="item.smsDetails[0].deliveryDetails && 'detailText' in item.smsDetails[0].deliveryDetails">
                        <div v-if='item.smsDetails[0].deliveryDetails.detailText.length > detailTextMaxLength'>
                          <a @click="showFullContent(item.smsDetails[0].deliveryDetails.err + ': ' + item.smsDetails[0].deliveryDetails.detailText)"
                             label="Show Delivery Details" onmouseover="this.style.cursor='pointer'">
                            {{ item.smsDetails[0].deliveryDetails.err }}:
                            {{ item.smsDetails[0].deliveryDetails.detailText }}
                          </a>
                        </div>
                        <div v-else>
                          {{ item.smsDetails[0].deliveryDetails.err }}: {{
                            item.smsDetails[0].deliveryDetails.detailText
                          }}
                        </div>
                      </template>
                      <template
                          v-else-if="item.smsDetails[0].deliveryDetails && 'detail' in item.smsDetails[0].deliveryDetails">
                        <div v-if='item.smsDetails[0].deliveryDetails.detail.length > detailTextMaxLength'>
                          <a @click="showFullContent(item.smsDetails[0].deliveryDetails.detail)"
                             label="Show Delivery Details" onmouseover="this.style.cursor='pointer'">
                            {{ item.smsDetails[0].deliveryDetails.detail }}
                          </a>
                        </div>
                        <div v-else style="color: olive">
                          {{ item.smsDetails[0].deliveryDetails.detail }}
                        </div>
                      </template>
                    </td>
                    <td v-if="isAdmin" class="smallercells toolbar__item item--show">
                      <a :href="'https://sbsweb.corproot.net/#/mtrac/%257B%2522message_type%2522%253A%2522sms%2522%252C%2522short_id%2522%253A%2522%2522%252C%2522limit%2522%253A%2522200%2522%252C%2522period%2522%253A%2522last_7d%2522%252C%2522sender%2522%253A%2522%2522%252C%2522receiver%2522%253A%2522'+ item.destination+'%2522%252C%2522start_date%2522%253A%2522%2522%252C%2522end_date%2522%253A%2522%2522%257D'"
                         target="SBS">
                        <i class="icon icon-link" aria-hidden="true" title="Summary"></i>
                      </a>
                    </td>
                    <td v-if="isAdmin && this.webId === 'all_apps'">
                      {{ item.clientId }}
                    </td>
                  </tr>

                  <!-- Expanded rows showing additional SMS details -->
                  <template v-if="expandedRows[item.id || itemIndex] && item.smsDetails.length > 1">
                    <tr v-for="(detail, detailIndex) in item.smsDetails" :key="`${itemIndex}-${detailIndex}`"
                        class="expanded-row">
                      <td class="table-cell smallercells"></td>
                      <td></td>
                      <td></td>
                      <td>{{ detail.status }}</td>
                      <td></td>
                      <td>{{ detail.sentOn }}</td>
                      <td v-if="isSwisscom" class="message-length">
                        <template v-if="detail.deliveryDetails && 'detailText' in detail.deliveryDetails">
                          <div v-if='detail.deliveryDetails.detailText.length > detailTextMaxLength'>
                            <a @click="showFullContent(detail.deliveryDetails.err + ': ' + detail.deliveryDetails.detailText)"
                               label="Show Delivery Details" onmouseover="this.style.cursor='pointer'">
                              {{ detail.deliveryDetails.err }}: {{ detail.deliveryDetails.detailText }}
                            </a>
                          </div>
                          <div v-else>
                            {{ detail.deliveryDetails.err }}: {{ detail.deliveryDetails.detailText }}
                          </div>
                        </template>

                        <template v-else-if="detail.deliveryDetails && 'detail' in detail.deliveryDetails">
                          <div v-if='detail.deliveryDetails.detail.length > detailTextMaxLength'>
                            <a @click="showFullContent(detail.deliveryDetails.detail)"
                               label="Show Delivery Details" onmouseover="this.style.cursor='pointer'">
                              {{ detail.deliveryDetails.detail }}
                            </a>
                          </div>
                          <div v-else style="color: olive">
                            {{ detail.deliveryDetails.detail }}
                          </div>
                        </template>
                        <template v-else>
                          <div>No details available</div>
                        </template>
                      </td>
                      <td v-if="isAdmin"></td>
                      <td v-if="isAdmin && webId === 'all_apps'"></td>
                    </tr>
                  </template>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="statisticOutbox.length === 0" class="no-items-found">
          <p><i>No outbox items found</i></p>
        </div>
        <div class="Modal-Design">
          <sdx-dialog
              type="modal"
              id="delivery-details"
              label="Delivery Details Content"
              icon-name="icon-delivery-details">
            <sdx-dialog-content class="detail-Content">
              <div class="margin-left-1 margin-bottom-3">
                {{ this.deliveryDetail }}
              </div>
              <sdx-button-group>
                <sdx-button
                    id="first-action-element"
                    label="Close"
                    onclick="document.getElementById('delivery-details').close()"
                    theme="primary">
                </sdx-button>
              </sdx-button-group>
            </sdx-dialog-content>
          </sdx-dialog>
        </div>
        <div class="row justify-content-between">
          <div class="col-xs">
            <div v-if="totalPages != 1" class="sms-outbox-pagination">
              <div v-bind:current-page="currentPage.number + 1" v-bind:total-pages="Math.ceil(totalElements / size)"
                   @pageChanged="search">
                <ul v-if="totalPages > 0" class="pagination">
                  <li class="pagination-item">
                    <sdx-button
                        id="firstPage"
                        type="button"
                        label="<<"
                        class="sdx-button"
                        @click="gotoPage(1)"
                        :disabled="isFirstPage"/>
                  </li>
                  <li class="pagination-item">
                    <sdx-button
                        id="onePageBackwards"
                        type="button"
                        label="<"
                        class="sdx-button"
                        @click="gotoPage(currentPage - 1)"
                        :disabled="isFirstPage"/>
                  </li>
                  <li v-for="page in pages" v-bind:key="page" class="pagination-item">
                      <span
                          v-if="page.placeholder"
                          class="pagination-button inactive"
                      >
                        ...
                      </span>
                    <button
                        v-else
                        type="button"
                        class="pagination-button"
                        @click="gotoPage(page.pageNumber)"
                        :class="`${page.currentPage ? 'active' : 'inactive'}`"
                    >
                      {{ page.pageNumber }}
                    </button>
                  </li>
                  <li class="pagination-item">
                    <sdx-button
                        id="nextPage"
                        type="button"
                        label=">"
                        class="sdx-button"
                        @click="gotoPage(currentPage + 1)"
                        :disabled="isLastPage"/>
                  </li>
                  <li class="pagination-item">
                    <sdx-button
                        id="lastPage"
                        type="button"
                        label=">>"
                        class="sdx-button"
                        @click="gotoPage(totalPages)"
                        :disabled="isLastPage"/>
                  </li>
                  <li class="pagination-item total-elements">
                    Total: {{ this.totalElements }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <div v-if="statisticOutbox.length !== 0" class="sms-outbox-export">
              <sdx-dialog
                  v-bind:id="'sms-outbox-export-modal'"
                  label="Would you like to export the search results?"
                  class="clearfix"
              >
                <sdx-dialog-toggle>
                  <sdx-button label="Export" id="ExportButton" data-testid="ExportButton"></sdx-button>
                </sdx-dialog-toggle>
                <sdx-dialog-content class="sms-outbox-export-content">
                  <div v-if="totalElements < 10000">
                    <p class="margin-bottom-1">
                      The current search results will be exported to Excel.
                    </p>
                  </div>
                  <div v-if="totalElements > 10000">
                    <p class="margin-bottom-1">
                      The current search results will be exported to Excel (Only 10'000 of {{ totalElements }} will be
                      exported).
                    </p>
                  </div>
                  <p>Generating the export may take some time.</p>
                  <p v-if="exportError" class="sms-outbox-export-modal-error">
                    {{ exportError }}
                  </p>
                  <sdx-button-group v-if="!isExporting">
                    <sdx-button
                        id="generateExport"
                        data-testid="generateExport"
                        label="Generate Export"
                        @click="exportData()"
                    ></sdx-button>
                    <sdx-button
                        id="cancel"
                        data-testid="cancel"
                        label="Cancel"
                        @click="closeModal()"
                        theme="secondary"
                    ></sdx-button>
                  </sdx-button-group>
                  <div
                      v-if="isExporting"
                      class="loader-spinner loader-spinner--large loader-spinner--plain"
                  >
                    <span class="sr-only">Exporting. Please wait.</span>
                  </div>
                </sdx-dialog-content>
              </sdx-dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utility, {addDate, formatDate} from "@/util/utility";
import dateService from "@/services/date.service";
import DevAppDropDownComponent from "@/components/DevAppDropDownComponent";
import FlagComponent from "@/components/FlagComponent";
import envService from "@/services/env.service";
import loadingSpinnerService from '@/services/loading-spinner.service';
import {logger} from "@/services/logger.service";
import {showAlert, showSuccess} from "@/services/notification.service";
import userService from "@/services/user.service";
import smsOutboxService from '../service';

export default {
  components: {
    FlagComponent,
    DevAppDropDownComponent,
  },
  data: function () {
    return {
      webId: undefined,
      statisticOutbox: [],
      totalPages: -1,
      pageNumber: -1,
      currentPage: -1,
      totalElements: -1,
      size: -1,
      page: [],
      showOutbox: false,
      isExporting: false,
      exportError: null,
      countryCode: [],
      destinationNumber: [],
      statusFilter: [],
      currentSmsDetails: [],
      tag: [],
      expandedRows: {},
      dateRange: {
        fromDate: dateService.getInitialFromDate(formatDate(addDate(new Date(), -envService.getDays4SmsSearch(), "days").setHours(0, 0, 0, 0))),
        formattedFromDate: undefined,
        toDate: dateService.getInitialToDate(formatDate(new Date().setHours(23, 59, 59, 999))),
        formattedToDate: undefined
      },
      smsMessage: [],
      messageId: [],
      delay: 1000,
      loadingData: false,
      lastLoad: '',
      isAdmin: false,
      isSwisscom: false,
      deliveryDetail: undefined,
      detailTextMaxLength: 40
    }
  },
  computed: {
    pages: function () {
      let previousPage = this.currentPage > 1 ? (this.currentPage - 1) : 1
      let nextPage = this.currentPage < this.totalPages ? (this.currentPage + 1) : this.totalPages
      let extraPreviousPage = previousPage === 3 ? 2 : null
      let extraNextPage = nextPage === (this.totalPages - 2) ? (this.totalPages - 1) : null
      let placeholderBefore = previousPage > 3 ? 2 : null
      let placeholderAfter = nextPage < (this.totalPages - 2) ? (this.totalPages - 1) : null

      let pages = []

      for (let i = 1; i <= this.totalPages; i += 1) {
        if ([1, this.totalPages, this.currentPage, previousPage, nextPage, extraPreviousPage, extraNextPage, placeholderBefore, placeholderAfter].includes(i)) {
          pages.push({
            pageNumber: i,
            currentPage: this.currentPage === i,
            placeholder: [placeholderBefore, placeholderAfter].includes(i)
          })
        }
      }
      return pages
    },
    isFirstPage: function () {
      return this.currentPage === 1
    },
    isLastPage: function () {
      return this.currentPage === this.totalPages
    },
    statusList: function () {
      return ['PROCESSING', 'DELIVERED', 'CONFIRMED', 'FAILURE', 'NO_INFO', 'BLOCKED']
    },
    envService() {
      return envService
    }
  },
  mounted() {
    if (this.$route.query.tag) {
      this.tag = this.$route.query.tag;
      logger.debug("tag: " + this.$route.query.tag)
    }
    this.setRights();
    dateService.updateFromDate(this.dateRange);
    dateService.updateToDate(this.dateRange);
  },
  methods: {
    async setRights() {
      this.isAdmin = await userService.isAdmin();
      this.isSwisscom = await userService.isSwisscom();
    },
    devAppChanged: async function (webId) {
      loadingSpinnerService.show("outbox")
      this.webId = webId;
      await this.loadData(1);
      loadingSpinnerService.hide("outbox")
    },
    loadData: async function (page) {
      loadingSpinnerService.show("outbox-content")
      let thisLoad = "loadData(" + page + ") with webId: " + this.webId +
          ", countryCode: " + this.countryCode +
          ", destinationNumber: " + this.destinationNumber +
          ", statusFilter: " + this.statusFilter +
          ", tag: " + this.tag +
          ", fromDate: " + this.dateRange.formattedFromDate +
          ", toDate: " + this.dateRange.formattedToDate;
      logger.debug("thisLoad: " + thisLoad);
      //already loaded?
      if (thisLoad === this.lastLoad) {
        logger.debug("loadData already running/runned with same parameters")
        return
      }
      this.lastLoad = thisLoad;
      //wait for loadingData to finish
      while (this.loadingData) {
        logger.debug("waiting for loadingData to finish")
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      this.loadingData = true;
      loadingSpinnerService.show("outbox-content")
      if (this.webId === undefined || this.webId === null || this.webId === '') {
        this.showOutbox = false
      } else {
        this.showOutbox = true;
        try {
          let response = await smsOutboxService.getSmsOutbox(this.webId,
              this.countryCode,
              this.destinationNumber,
              this.statusFilter,
              this.tag,
              this.dateRange.formattedFromDate,
              this.dateRange.formattedToDate,
              page - 1,
              20,
              "createdOn,DESC");
          this.statisticOutbox = response.data.content;
          this.totalPages = response.data.totalPages;
          this.pageNumber = response.data.pageNumber;
          this.currentPage = response.data.number + 1;
          this.totalElements = response.data.totalElements;
          this.size = response.data.size;
        } catch (error) {
          logger.debug("Error: " + error)
          showAlert(error.message)
          this.statisticOutbox = []
        }
      }
      setTimeout(() => {
        this.loadingData = false;
        loadingSpinnerService.hide("outbox-content");
      }, 1000)
    },
    gotoPage: function (page) {
      this.loadData(page);
      this.$emit('pageChanged', page);
    },
    initTimeOutForLoadingData: function () {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        this.loadData(1);
      }, this.delay);
    },
    handleTextInputChange(value, field) {
      this[field] = value !== '' ? value : null;
      this.initTimeOutForLoadingData();
    },
    statusFilterChange: function () {
      this.statusFilter = arguments[0].target.value;
      this.initTimeOutForLoadingData();
    },
    fromDateChange: async function () {
      await dateService.fromDateChange(arguments[0].target.value, this.dateRange);
      this.initTimeOutForLoadingData();
    },
    toDateChange: async function () {
      await dateService.toDateChange(arguments[0].target.value, this.dateRange);
      this.initTimeOutForLoadingData();
    },
    exportData: async function () {
      this.exportError = null
      this.isExporting = true
      try {
        const response = await smsOutboxService.getOutboxExport(this.webId, this.countryCode, this.destinationNumber, this.statusFilter, this.tag, this.dateRange.formattedFromDate, this.dateRange.formattedToDate);
        logger.debug("download response: " + JSON.stringify(response))
        utility.download(
            response.data,
            response.data.type,
            response.headers,
            "Sent SMS Export.xlsx"
        );
        showSuccess("Download complete")
      } catch (error) {
        this.exportError = error
        showAlert(error.message)
      }
      this.isExporting = false
      this.closeModal();
    },
    closeModal: function () {
      document.getElementById('sms-outbox-export-modal')
          .close()
      setTimeout(() => {
        this.exportError = null
      }, 150)
    },
    showFullContent: function (deliveryDetail) {
      this.deliveryDetail = deliveryDetail;
      document.getElementById('delivery-details').open()
    },
    toggleRowExpansion: function (item) {
      const itemId = item.id || this.statisticOutbox.indexOf(item);
      this.expandedRows[itemId] = !this.expandedRows[itemId];
    }
  }
};
</script>

<style scoped>

.filter-item {
  padding-right: 10px;
  padding-left: 0;
  padding-top: 3px;
  min-width: 200px;
}

.filter-item-title {
  padding-right: 5px;
  font-size: 15px;
}

.smallercells {
  padding: 5px;
}

.subscription-table .table-cell {
  padding-top: 5px;
  padding-bottom: 2px;
  border-radius: 20px;
}

.subscription-table.table tbody td {
  padding-top: 5px;
  padding-bottom: 3px;
}

.total-elements {
  padding: 11px 23px;
}

.pagination {
  list-style-type: none;
}

.pagination-item {
  display: inline-block;
}

.sdx-button {
  min-width: 48px !important;
  min-height: 51px !important;
  margin-left: 2px;
  margin-right: 2px;
}

.pagination-button {
  padding: 11px 23px;
  border-radius: 5px;
  margin-left: 2px;
  margin-right: 2px;
}

.pagination-button.inactive {
  background-color: rgb(207, 213, 217);
  color: rgb(51, 51, 51);
  border: 1px solid rgb(207, 213, 217);;
}

.sms-outbox-pagination {
  margin-bottom: 40px;
}

.sms-outbox-export {
  float: right;
}

.sms-outbox-export-content {
  max-width: 650px;
}

.sms-outbox-export-modal-error {
  color: rgb(228, 102, 109);
  background-color: rgba(255, 210, 210, 0.7);
  padding: 3px 12px;
  border-radius: 5px;
}

.legendStatusName {
  vertical-align: top;
}

.message-length {
  max-width: 230px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-Content {
  max-width: 50%;
}

.expandable-indicator {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-left: 5px;
  border-radius: 3px;
  background-color: #f0f0f0;
  transition: background-color 0.2s;
}

.expandable-indicator:hover {
  background-color: #e0e0e0;
}

.expandable-indicator .icon {
  font-size: 12px;
  color: #0066cc;
}

.sms-outbox-row {
  cursor: default;
}

.expanded-row {
  background-color: #f9f9f9;
  height: 39px;
}

</style>
